export default __webpack_public_path__ + "static/media/ic-camera-off-dark.a45fb50e.svg";